import {Component} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutService } from './service/app.layout.service';


@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [TranslateModule],
    template: `
        <div class="layout-footer">
            <div class="footer-logo-container">
                <img id="footer-logo"   [src]="'assets/layout/images/logo-'+ (layoutService.config().colorScheme === 'light' ? 'dark' : 'light') + '.png'" alt="insight-gainer-layout"/>
                <span class="app-name">{{'appName' | translate}}</span>
            </div>
            <span class="copyright">{{'copyRight' | translate}}</span>
        </div>
    `
})
export class AppFooterComponent {
    constructor(public layoutService: LayoutService) {}
}
